module.exports = __webpack_public_path__ + "803c3dd8278279f721ae236913d643b9.svg";